import { Model } from 'modules/core/lib/mobx-rest'

interface ITaskType {
  id: number
  title: string
  translated_title?: string
  identifier: string
  incidence_name: string
  leave_type_id: number
  company_id: number
  folder_id: number
  folder_type: string
  folder_identifier: string
}

class TaskType extends Model<ITaskType> {
  static urlRoot() {
    return '/bookkeepers_management/tasks/task_types'
  }
}

export default TaskType
